<template>
  <div class="user-container">
    <el-dropdown trigger="click">
      <span class="el-dropdown-link">
        <img v-if="user && user.photo" :src="user.photo" />
        <img
          v-else
          src="https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=3210116116,2698637809&fm=58"
          class="user-avatar"
        />
        {{ this.user && this.user.name ? this.user.name : "管理员" }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="personal"
          >个人信息
          <!-- <span @click="personal">个人信息</span> -->
        </el-dropdown-item>
        <el-dropdown-item @click.native="logout"
          >退出
          <!-- <span @click="logout">退出</span> -->
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { removeToken } from '@/utils/auth'
export default {
  data () {
    return {
      user: false
    }
  },
  created () {
    if (localStorage.user) {
      this.user = JSON.parse(localStorage.user)
    }
  },

  methods: {
    logout () {
      removeToken()
      localStorage.clear()
      this.$store.state.home.RoleId = null
      this.$store.state.home.permission = []
      this.$router.push({ name: 'Login' })
    },
    personal () {
      const id = JSON.parse(localStorage.user).userId
      this.$router.push({ name: 'UserPersonal', query: { id: id } })
    }
  }
}
</script>

<style lang="less" scoped>
.user-container {
  .el-dropdown-link {
    img {
      margin-right: 14px;
      position: relative;
      top: 15px;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      border: 2px solid #fff;
    }
  }
}
</style>
<style lang="less">
.user-container {
  .el-dropdown {
    font-size: 16px;
    color: #fff;
    .el-dropdown-link {
      cursor: pointer;
    }
  }
}
</style>